<template>
    <DxDataGrid :data-source="dsAtribute" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopupGrid :closeOnOutsideClick="false" :showCloseButton="false" :width="390" :height="390" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopupGrid>
            <DxFormGrid :col-count="2">
                <DxItem 
                    data-field="AtributCategorieID"
                    editor-type="dxLookup"
                    :editor-options="{ 
                        dataSource: dsAtributeCategorii,
                        valueExpr: 'Id',     
                        displayExpr: 'Denumire',
                        height: 50
                    }"
                /> 
                <DxItem data-field="Cod" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Nume" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Tip" editor-type="dxNumberBox" :editor-options="numberBoxTipOptions"/>
                <DxItem data-field="Initial" :editor-options="{ height: 50 }"/>
                <DxItem data-field="order" editor-type="dxNumberBox" :editor-options="numberBoxOrderOptions"/>
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Atribut
            </div>
        </template>

        <DxColumn data-field="AtributCategorieID" :visible="false" :allow-search="false"/>
        <DxColumn data-field="Categorie" caption="Categorie" :visible="false"/>
        <DxColumn data-field="Cod" caption="Cod"/>
        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="Tip" caption="Tip"/>
        <DxColumn data-field="Initial" caption="Initial"/>
        <DxColumn data-field="order" caption="Order"/>

        <DxToolbar>
            <DxItem location="before">
                <template #default>
                    <div style="display: flex; align-items: center;">
                        <span style="margin-right: 10px; font-weight: bold;">Categorie:</span>
                        <DxLookup :data-source="dsAtributeCategorii"
                                :value="filtru"
                                value-expr="Id"
                                display-expr="Denumire"
                                height="40px"
                                @value-changed="onCategorieValueChanged"/>
                            <DxDropDownOptions :show-title="false" />
                    </div>
                </template>
            </DxItem>
            <DxItem  location="before">
                <template #default>
                    <DxButton icon="menu" type="default" hint="Gestionează Categorii" @click="openManagePopup" />
                </template>
            </DxItem>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" hint="Adaugă un atribut" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="390" height="390">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Atribut
            </div>
        </template>
        <DxForm :col-count="2" :data-dource="newAtribut">
            <DxSimpleItem data-field="Categorie">
                <template #default>
                    <DxTextArea :value="categorie" :readOnly="true" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Cod" :is-required="true">
                <template #default>
                    <DxTextArea :value="newAtribut.Cod" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newAtribut.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Tip">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newAtribut.Tip" @value-changed="onTipValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Initial">
                <template #default>
                    <DxTextArea :value="newAtribut.Initial" @value-changed="onInitialValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Order">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newAtribut.order" @value-changed="onOrderValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
    <DxPopup :visible="managePopupVisible" :show-title="true" width="390" height="390">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Gestionează Categorii
            </div>
        </template>
        <div class="manage-content">
            <div class="add-section">
                <DxTextBox v-model:value="newCategoryName" placeholder="Nume categorie nouă..." width="100%" :value-change-event="'input'"/>
                <DxButton icon="add" type="success" @click="onSaveNewCategory" styling-mode="contained" class="circle-btn" :disabled="!newCategoryName"/>
            </div>
            <div class="separator"></div>
            <DxScrollView height="100%">
                <div class="category-list">
                    <div v-for="cat in localCategoriesList" :key="cat.Id" class="category-row">
                        <template v-if="editingId !== cat.Id">
                            <span class="cat-name">{{ cat.Denumire }}</span>
                            <div class="actions">
                                <DxButton icon="edit" styling-mode="contained" class="circle-btn" @click="startEdit(cat)" />
                                <DxButton icon="trash" styling-mode="contained" class="circle-btn" type="danger" @click="deleteCategory(cat.Id)" />
                            </div>
                        </template>
                        <template v-else>
                            <DxTextBox v-model:value="editingName" width="100%" />
                            <div class="actions">
                                <DxButton icon="check" type="success" styling-mode="contained" class="circle-btn" @click="saveEdit(cat.Id)" />
                                <DxButton icon="close" type="danger" styling-mode="contained" class="circle-btn" @click="cancelEdit" />
                            </div>
                        </template>
                    </div>
                    <div v-if="localCategoriesList.length === 0" style="text-align:center; padding: 20px; color: #999;">
                        Nu există categorii.
                    </div>
                </div>
            </DxScrollView>
        </div>
        <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="closeManageOptions" />
    </DxPopup>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxItem,
        DxPopup as DxPopupGrid,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem, DxPopup } from 'devextreme-vue/popup';
    import { DxNumberBox } from "devextreme-vue/number-box";
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxLookup, DxDropDownOptions } from 'devextreme-vue/lookup';
    import RU_Atribute from '@/services/RU/RU_Atribute';
    import { DxScrollView, DxTextBox } from 'devextreme-vue';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox,
            DxSelectBox,
            DxLookup,
            DxDropDownOptions,
            DxTextBox,
            DxScrollView,
            DxPopupGrid
        },
        data() {
            return {
                dsAtribute: {} as DataSource,
                dsAtributeCategorii: new DataSource({
                    store: {
                        type: 'odata',
                        url: AppSetting.API_Url_ResurseUmaneOdata + 'RU_AtributeCategorii',
                        key: 'Id',
                        keyType: "Guid",
                        version: 4,
                        beforeSend: (e: any) => {
                            e.headers = {
                                "Content-Type": "application/json",
                                "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                            }
                        }
                    }
                }),
                addPopupVisible: false,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                filtru: null,
                categorie: '',
                newAtribut: {
                    Categorie: '',
                    Cod: '',
                    Nume: '',
                    Tip: 0,
                    Initial: null,
                    order: 0,
                    AtributCategorieID: null
                },
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                },
                numberBoxTipOptions: {
                    min: 0,
                    step: 1,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50
                },
                numberBoxOrderOptions: {
                    min: 0,
                    step: 1,
                    showSpinButtons: true,
                    showClearButton: true,
                    height: 50
                },
                managePopupVisible: false,
                localCategoriesList: [] as any[],
                newCategoryName: '',
                editingId: null as string | null,
                editingName: '',
            }
        },
        computed: {
            closeManageOptions() {
                return {
                    text: "Închide",
                    type: "danger",
                    stylingMode: "contained",
                    onClick: () => { 
                        this.managePopupVisible = false; 
                    }
                };
            }
        },
        async mounted() {
            this.dsAtribute = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `RU_Atribute`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
                filter: ["AtributCategorieID", "=", this.filtru],
            })
            try {
                const categories = await this.dsAtributeCategorii.load();
                if (categories && categories.length > 0) {
                    this.filtru = categories[0].Id
                    this.categorie = categories[0].Denumire
                    this.dsAtribute.filter(["AtributCategorieID", "=", this.filtru])
                    this.dsAtribute.load()
                }
            } catch (error) {
                console.error("Could not load default category filter", error)
            }
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
        },
        methods: {
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            async onCategorieValueChanged(e: any) {
                this.filtru = e.value
                try {
                    const store = this.dsAtributeCategorii.store();
                    const selectedCategory = await store.byKey(this.filtru);

                    if (selectedCategory) {
                        this.categorie = selectedCategory.Denumire; 
                    }
                    
                    this.dsAtribute.filter(["AtributCategorieID", "=", this.filtru]);
                    this.dsAtribute.load();
                } catch (error) {
                    console.error("Could not find category with ID: " + this.filtru);
                }
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newAtribut = {
                    Categorie: '',
                    Cod: '',
                    Nume: '',
                    Tip: 0,
                    Initial: null,
                    order: 0,
                    AtributCategorieID: null
                }
            },
            onCodValueChanged(e: any) {
                this.newAtribut.Cod = e.value
            },
            onNumeValueChanged(e: any) {
                this.newAtribut.Nume = e.value
            },
            onTipValueChanged(e: any) {
                this.newAtribut.Tip = e.value
            },
            onInitialValueChanged(e: any) {
                this.newAtribut.Initial = e.value
            },
            onOrderValueChanged(e: any) {
                this.newAtribut.order = e.value
            },  
            onSaveAdd() {
                if (!this.newAtribut.Cod || this.newAtribut.Cod.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Cod'!", "error", 3000)
                    return
                }
                if (!this.newAtribut.Nume || this.newAtribut.Nume.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                this.newAtribut.Categorie = this.categorie
                this.newAtribut.AtributCategorieId = this.filtru
                
                RU_Atribute.save(this.newAtribut).then((atribut) => {
                    this.addPopupVisible = false
                    this.newAtribut = {
                        Categorie: '',
                        Cod: '',
                        Nume: '',
                        Tip: 0,
                        Initial: null,
                        order: 0,
                        AtributCategorieID: null
                    }
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                })
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            async openManagePopup() {
                console.log("ajung aici!!!!!!!!")
                this.managePopupVisible = true
                console.log(this.managePopupVisible)
                this.loadCategoriesList()
            },
            async loadCategoriesList() {
                try {
                    const store = this.dsAtributeCategorii.store();
                    this.localCategoriesList = await store.load({ sort: [{ selector: "Denumire", desc: false }] });
                } catch (error) {
                    console.error(error);
                    notify("Eroare la încărcarea categoriilor", "error", 2000);
                }
            },
            async onSaveNewCategory() {
                if (!this.newCategoryName.trim()) return;

                try {
                    const store = this.dsAtributeCategorii.store();
                    await store.insert({ 
                        Denumire: this.newCategoryName 
                    });

                    notify("Categorie adăugată!", "success", 2000);
                    this.newCategoryName = "";
                    await this.loadCategoriesList();
                    await this.dsAtributeCategorii.load() 
                } catch (error) {
                    console.error(error);
                    notify("Eroare la adăugare", "error", 2000);
                }
            },
            async deleteCategory(id: string) {
                try {
                    const store = this.dsAtributeCategorii.store();
                    await store.remove(id);
                    notify("Categorie ștearsă!", "success", 2000);
                    await this.loadCategoriesList(); 
                    await this.dsAtributeCategorii.load()
                    if (this.filtru === id) {
                        this.filtru = null;
                        this.categorie = '';
                        this.dsAtribute.filter(null);
                        this.dsAtribute.load();
                    }
                } catch (error) {
                    console.error(error);
                    notify("Nu se poate șterge (posibil utilizată)", "error", 2000);
                }
            },
            startEdit(category: any) {
                this.editingId = category.Id;
                this.editingName = category.Denumire;
            },
            cancelEdit() {
                this.editingId = null;
                this.editingName = "";
            },
            async saveEdit(id: string) {
                if (!this.editingName.trim()) return;
                try {
                    const store = this.dsAtributeCategorii.store();
                    
                    await store.update(id, { Denumire: this.editingName });
                    await this.dsAtributeCategorii.load()
                    notify("Categorie modificată!", "success", 2000);
                    this.cancelEdit();
                    await this.loadCategoriesList(); 
                    
                    if (this.filtru === id) {
                        this.categorie = this.editingName;
                    }
                } catch (error) {
                    console.error(error);
                    notify("Eroare la modificare", "error", 2000);
                }
            },
            onManagePopupHidden() {
                this.dsAtributeCategorii.load();
            }
        }
    })
</script>
<style scoped>
/* Container principal */
.manage-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px;
}

/* Sectiunea de adaugare sus */
.add-section {
    display: flex;
    gap: 10px; /* Spatiu intre input si butonul de add */
    align-items: center;
    margin-bottom: 15px;
}

/* Linia separator */
.separator {
    height: 1px;
    background-color: #e0e0e0;
    margin-bottom: 10px;
}

/* Randul unei categorii */
.category-row {
    display: flex; /* Asta pune elementele pe acelasi rand */
    justify-content: space-between; /* Impinge textul la stanga si butoanele la dreapta */
    align-items: center; /* Le centreaza vertical */
    padding: 8px 5px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
}

.category-row:hover {
    background-color: #f9f9f9;
}

.cat-name {
    font-weight: 500;
    font-size: 14px;
    color: #333;
}

/* Container pentru butoanele de actiune */
.actions {
    display: flex;
    gap: 8px; /* Spatiu intre butoanele de edit si delete */
}

/* CLASA PENTRU BUTOANE ROTUNDE (CERCULETE) */
.circle-btn {
    width: 32px !important;  /* Latime fixa mica */
    height: 32px !important; /* Inaltime egala cu latimea */
    border-radius: 50% !important; /* Le face perfect rotunde */
    padding: 0 !important;
    min-width: unset !important;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* O umbra fina */
}

/* Ajustare iconita in interiorul cercului */
.circle-btn .dx-icon {
    font-size: 16px !important;
    margin: 0 !important;
}

.empty-state {
    text-align: center;
    padding: 20px;
    color: #999;
    font-style: italic;
}
</style>